import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { DropDownButton } from "@progress/kendo-react-buttons";
import { toast } from "react-toastify";

import styles from "./Casefile.module.scss";
import { getClientData, getClientLoginAccess, getMatterAllInfo } from "api";
import { getMattersAllURLInfo } from "actions/matters.action";

import CaseActivitiesPage from "./CaseActivities/CaseActivitiesPage";
import MatterLedgerCardPage from "pages/Matters/MattersLedgerCardPage";
import CaseContactsPage from "../CaseFile/CaseContactsPage";
import { PageTabItemTitle } from "components/tabs/TabItem/PageTabItemTitle";
import CaseWorkFlows from "./CaseWorkFlow/CaseWorkFlow";
import TimeRecorded from "components/Time/TimeRecorded";
import MatterForm from "pages/Matters/MatterForm";
import AddClients from "pages/Clients/AddViewClients";
import BillingGuideModal from "./BillingGuideModal";
import EmailCompletion from "components/common/EmailComposition";
import CaseTasks from "./CaseTasks";
import useFilterState from "../../components/CaseFiles/useFilterState";
import EmailDialog from "components/common/EmailComposition/EmailDialog";
import ChitRequest from "pages/ChitRequest/ChitRequest";
import { ClientServices } from "./ClientServices";
import SearchTextBox from "components/SearchComponent";

/*** IMPORT ICONS*/
import { arrowRotateCwIcon as refreshIcon } from "@progress/kendo-svg-icons";
import MatterIcon from "../../assets/CaseFileIcons/matter.svg";

import ClientIcon from "../../assets/CaseFileIcons/client.svg";
import mail from "../../assets/CaseFileIcons/newEmail.svg";
import filtersAppliedIcon from "../../assets/CaseFileIcons/FilterApplied.svg";
import ChitRequestIcon from "../../assets/CaseFileIcons/chit-request.svg";
import billingIcon from "../../assets/CaseFileIcons/billingGuide.svg";
import ConflictCheckImage from "../../assets/CaseFileIcons/conflict-check.svg";
import ClientDropDown from "../../assets/CaseFileIcons/app-bar/client.svg";
import ChitRequestDropDown from "../../assets/CaseFileIcons/app-bar/chit-request.svg";
import BillingRequestIcon from "../../assets/CaseFileIcons/billing-request.svg";
import BillingRequestDropDown from "../../assets/CaseFileIcons/app-bar/billing-request.svg";
import ConflictCheckDropDown from "../../assets/CaseFileIcons/app-bar/conflict-check.svg";
import BillingGuideDropDown from "../../assets/CaseFileIcons/app-bar/billing-guide.svg";
import EmailDropDown from "../../assets/CaseFileIcons/app-bar/email.svg";
import MatterDropdown from "../../assets/CaseFileIcons/app-bar/matter.svg";
import { MdArrowDropDown } from "react-icons/md";
import { FaFilter } from "react-icons/fa";
import ConflictCheck from "./ConflictCheck";
import { ClientIdVerification } from "./ClientServices/ClientServicesTasks/IdVerification";
import BillingRequestModal from "pages/Bills/BillingRequestModal";

const options = [
    "Activities",
    "Time Recording",
    "Tasks",
    "Work Flows",
    "Client Services",
    "Contacts",
    "Ledger Card",
];

const itemRender = (props) => {
    return (
        <div className="flex items-center mt-1 gap-2">
            {props.item.icon && (
                <img
                    src={props.item.icon}
                    className="k-mr-3 flex-shrink-0"
                    style={{
                        width: "18px",
                        height: "18px",
                    }}
                    alt="item icon"
                />
            )}
            <span className="flex-grow">{props.item.text}</span>
        </div>
    );
};

const CaseFileView = (props) => {
    const [currentMatterDetails, setcurrentMatterDetails] = useState([]);
    const [billingRequestMatter, setBillingRequestMatter] = useState(false);
    const [activeItem, setActiveItem] = useState(0);
    const [addActivity, setAddActivity] = useState(false);
    const [attachContact, setAttachContact] = useState(false);
    const [reference, setReference] = useState();
    const [clientReference, setClientReference] = useState();    
    const [openEmailCompletion, setOpenEmailCompletion] = useState(false);
    const [openExistingEmailCompletion, setOpenExistingEmailCompletion] =
        useState();
    const [editData, setEditData] = useState({});
    const [showClientForm, setShowClientForm] = React.useState(false);
    const [addTime, setAddTime] = useState(false);
    const [addTask, setAddTask] = useState(false);
    const [showScreens, setShowScreens] = useState(false);
    const [showMatterForm, setshowMatterForm] = React.useState(false);
    const [editWorkflow, setEditWorkflow] = useState(false);
    const [showClientView, setshowClientView] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [refreshClicked, setRefreshClicked] = useState(false);
    const [showBillingGuide, setShowBillingGuide] = useState(false);
    const [showChitRequest, setShowChitRequest] = useState(false);
    const [showConflictCheck, setShowConflictCheck] = useState(false);
    const [clientTask, setClientTask] = useState();
    const [activitySearch, setActivitySearch] = useState("");
    const searchRef = useRef();

    const filterAnchorRef = useRef(null);
    const filterContentRef = useRef(null);

    const activitiesFilterState = useFilterState();
    const timeRecordingFilterState = useFilterState();
    const tasksFilterState = useFilterState();
    const [isAddActivityBtn, setIsAddActivityBtn] = useState(false);

    useEffect(() => {
        async function getMatterInfo() {
            const datas = await getMatterAllInfo(props?.id);
            setcurrentMatterDetails(datas?.data?.data);
        }
        getMatterInfo();
    }, [props?.id]);

    const handleSearchChange = (value) => {
        setActivitySearch(value);
    };

    const clientsDataGetter = async (id) => {
        try {
            setIsLoading(true);
            const data = await getClientData(id);
            setEditData(data?.data?.data);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            alert("No client exists against this Id. Try again with different Id");
            navigate("/clients");
        }
    };
       

    const navigateToClientPortal = async (id) => {
        try {
            setIsLoading(true);
            const response = await getClientLoginAccess(
                currentMatterDetails?.clientId,
                currentMatterDetails?.matterId
            );

            // Assuming the URL is in response.data.url
            const clientPortalUrl = response.data;

            if (clientPortalUrl) {
                window.open(clientPortalUrl, "_blank"); // Open the URL in a new tab
            } else {
                toast.error("Invalid URL received from the server.");
            }
            setIsLoading(false); // Stop loading after navigation
        } catch (error) {
            setIsLoading(false);
            toast.error("Not found");
        }
    };

    const onClientRefClickActions = () => {
        setClientReference(currentMatterDetails?.clientRef);
        clientsDataGetter(currentMatterDetails?.clientId);
        setshowClientView(true);
    };

    const mattersDataGetter = async (id) => {
        try {
            dispatch(getMattersAllURLInfo(currentMatterDetails, false));
        } catch (error) {
            alert("No matter exists against this Id. Try again with different Id");
            navigate("/matters");
        }
    };

    const onMatterRefClickActions = (props) => {
        // navigate(`/matters/${props.dataItem.matterId}`);
        setReference(currentMatterDetails?.matterRef);
        mattersDataGetter(currentMatterDetails?.matterId);
        setshowMatterForm(true);
    };

    const actionButtonItems = [
        {
            text: "Client",
            icon: ClientDropDown,
            action: onClientRefClickActions,
        },
        {
            text: "Matter",
            icon: MatterDropdown,
            action: onMatterRefClickActions,
        },
        {
            text: "Conflict Check",
            icon: ConflictCheckDropDown,
            action: () => setShowConflictCheck(true),
        },
        {
            text: "Billing Guide",
            icon: BillingGuideDropDown,
            action: () => setShowBillingGuide(true),
        },
        {
            text: "Chit Request",
            icon: ChitRequestDropDown,
            action: () => setShowChitRequest(true),
        },
        {
            text: "Billing Request",
            icon: BillingRequestDropDown,
            action: () => setBillingRequestMatter(currentMatterDetails),
        },
        {
            text: "Email",
            icon: EmailDropDown,
            action: () => setOpenEmailCompletion(true),
        },
    ];

    const servicesButtonItems = [
        {
            text: "Data Collection Form",
            action: () => setShowScreens(true),
        },
        {
            text: "Data Collection File",
            // action: () => {},
        },
        {
            text: "ID Verification",
            action: () => setClientTask("ID-Verification"),
        },
        {
            text: "Request Documents",
            // action: () => {},
        },
        {
            text: "Sign Documents",
            // action: () => {},
        },
        {
            text: "Funds on Account",
            // action: () => {},
        },
    ];

    const headerIcons = [
        {
            title: "Email",
            src: mail,
            alt: "Email Icon",
            width: 18,
            height: 18,
            onClick: () => setOpenEmailCompletion(true),
        },
        {
            title: "Chit Request",
            src: ChitRequestIcon,
            alt: "Chit Request Icon",
            width: 18,
            height: 18,
            onClick: () => setShowChitRequest(true),
        },
        {
            title: "Billing Request",
            src: BillingRequestIcon,
            alt: "Billing Request Icon",
            width: 18,
            height: 18,
            onClick: () => setBillingRequestMatter(currentMatterDetails),
        },
        {
            title: "Billing Guide",
            src: billingIcon,
            alt: "Billing Guide Icon",
            width: 18,
            height: 18,
            onClick: () => setShowBillingGuide(true),
        },
        {
            title: "Conflict Check",
            src: ConflictCheckImage,
            alt: "Conflict Check Icon",
            width: 18,
            height: 18,
            onClick: () => setShowConflictCheck(true),
        },
        {
            title: "Matter",
            src: MatterIcon,
            alt: "Matter Icon",
            width: 18,
            height: 18,
            onClick: () => onMatterRefClickActions(),
        },
        {
            title: "Client",
            src: ClientIcon,
            alt: "Client Icon",
            width: 20,
            height: 20,
            onClick: () => onClientRefClickActions(),
        },
    ];

    return (
        <div className={`page h-100 d-flex flex-column ${props.isStandAlone ? "pt-1" : ""}`}>

            <div id="CaseFileHeader" className="mb-3">
                <div className={`${styles.legalProceeding} w-100 align-items-center d-flex justify-content-between px-4`} >

                    <div className={`${styles["sub-text"]}`}>
                        {!props.isStandAlone && (
                            <>
                                {currentMatterDetails?.client?.clientName} -{" "}
                                <u>{currentMatterDetails?.matterRef}</u> -{" "}
                                <b className={`${styles.headerMatterDetails} `}>
                                    {currentMatterDetails?.details}{" "}
                                </b>
                                {currentMatterDetails?.appCode && (
                                    <span> - [{currentMatterDetails?.appCode}]</span>
                                )}
                            </>
                        )}
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        {headerIcons.map((icon) => (
                            <Tooltip key={icon.title} anchorElement="target" position="top">
                                <Button
                                    title={icon.title}
                                    onClick={icon.onClick}
                                    look="flat"
                                    className={`${styles["image-block"]} d-flex align-items-center justify-content-center p-0`}
                                >
                                    <img
                                        title={icon.title}
                                        src={icon.src}
                                        alt={icon.alt}
                                        width={icon.width}
                                        height={icon.height}
                                        style={icon.style}
                                    />
                                </Button>
                            </Tooltip>
                        ))}

                        <DropDownButton
                            text="Actions"
                            items={actionButtonItems}
                            popupSettings={{
                                animate: false,
                                popupClass: styles["popup"],
                            }}
                            itemRender={itemRender}
                            onItemClick={(e) => e.item.action?.()}
                        />
                    </div>

                </div>
            </div>

            <div className="case-files-tab flex-grow-1 overflow-auto">

                <div className="position-relative h-100 w-100">

                    <div className="d-flex"
                        style={{
                            position: "absolute",
                            right: "0px",
                            top: "0px",
                            zIndex: 10,
                            maxWidth: "400px",
                        }}
                    >
                        {activeItem === 0 && (
                            <>
                                <SearchTextBox
                                    width={"200px"}
                                    height={"35px"}
                                    ref={searchRef}
                                    changeFilterValue={handleSearchChange}
                                />
                                <div
                                    ref={filterAnchorRef}
                                    onClick={() =>
                                        activitiesFilterState.setFilterClicked(
                                            !activitiesFilterState.filterClicked
                                        )
                                    }
                                >
                                    {!activitiesFilterState.filterApplied ? (
                                        <Button
                                            className={`${styles["commonButtonStyle"]} common-btn mx-2 p-2`}
                                        >
                                            <FaFilter color="white" size={16} />
                                        </Button>
                                    ) : (
                                        <Button
                                            className={`${styles["commonButtonStyle"]} common-btn mx-2 p-2`}
                                        >
                                            <img
                                                src={filtersAppliedIcon}
                                                alt="Filters Applied"
                                                width={25}
                                                height={25}
                                            />
                                        </Button>
                                    )}
                                </div>
                                <div>
                                    <Button
                                        className={`${styles["commonButtonStyle"]} common-btn me-2`}
                                        svgIcon={refreshIcon}
                                        style={{
                                            zIndex: "100",
                                        }}
                                        onClick={() => {
                                            setRefreshClicked(true);
                                        }}
                                    ></Button>
                                </div>
                                <Button
                                    style={{
                                        width: "100px",
                                        minWidth: "100px",
                                        height: "35px",
                                        zIndex: "100",
                                    }}
                                    className="common-btn"
                                    onClick={() => {
                                        setAddActivity(true);
                                        setIsAddActivityBtn(true);
                                    }}
                                >
                                    Add Activity
                                </Button>
                            </>
                        )}

                        {activeItem === 1 && (
                            <>
                                <div
                                    ref={filterAnchorRef}
                                    onClick={() =>
                                        timeRecordingFilterState.setFilterClicked(
                                            !timeRecordingFilterState.filterClicked
                                        )
                                    }
                                >
                                    {!timeRecordingFilterState.filterApplied ? (
                                        <Button
                                            className={`${styles["commonButtonStyle"]} common-btn me-2 p-2`}
                                        >
                                            <FaFilter color="white" size={16} />
                                        </Button>
                                    ) : (
                                        <Button
                                            className={`${styles["commonButtonStyle"]} common-btn me-2 p-2`}
                                        >
                                            <img
                                                src={filtersAppliedIcon}
                                                alt="Filters Applied"
                                                width={25}
                                                height={25}
                                            />
                                        </Button>
                                    )}
                                </div>
                                <Button
                                    className={`${styles["commonButtonStyle"]} common-btn me-2`}
                                    svgIcon={refreshIcon}
                                    onClick={() => {
                                        setRefreshClicked(true);
                                    }}
                                ></Button>

                                <Button
                                    style={{
                                        width: "100px",
                                        minWidth: "100px",
                                        height: "35px",
                                        zIndex: "100",
                                    }}
                                    className="common-btn"
                                    onClick={() => setAddTime(true)}
                                >
                                    Add Time
                                </Button>
                            </>
                        )}

                        {activeItem === 2 && (
                            <>
                                <div
                                    ref={filterAnchorRef}
                                    onClick={() =>
                                        tasksFilterState.setFilterClicked(
                                            !tasksFilterState.filterClicked
                                        )
                                    }
                                >
                                    {!tasksFilterState.filterApplied ? (
                                        <Button
                                            className={`${styles["commonButtonStyle"]} common-btn me-2 p-2`}
                                        >
                                            <FaFilter color="white" size={16} />
                                        </Button>
                                    ) : (
                                        <Button
                                            className={`${styles["commonButtonStyle"]} common-btn me-2 p-2`}
                                        >
                                            <img
                                                src={filtersAppliedIcon}
                                                alt="Filters Applied"
                                                width={25}
                                                height={25}
                                            />
                                        </Button>
                                    )}
                                </div>
                                <Button
                                    className={`${styles["commonButtonStyle"]} common-btn me-2 `}
                                    svgIcon={refreshIcon}
                                    onClick={() => {
                                        setRefreshClicked(true);
                                    }}
                                ></Button>

                                <Button
                                    style={{
                                        width: "100px",
                                        minWidth: "100px",
                                        height: "35px",
                                        zIndex: "100",
                                    }}
                                    className="common-btn"
                                    onClick={() => setAddTask(true)}
                                >
                                    Add Task
                                </Button>
                            </>
                        )}

                        {activeItem === 3 && (
                            <div>
                                <Button
                                    className={`${styles["commonButtonStyle"]} common-btn me-2 `}
                                    svgIcon={refreshIcon}
                                    onClick={() => {
                                        setRefreshClicked(true);
                                    }}
                                ></Button>

                                <Button
                                    className={`${styles["wideButtonStyle"]} common-btn `}
                                    onClick={() => setEditWorkflow(!editWorkflow)}
                                >
                                    {editWorkflow ? "Exit Edit Mode" : "Edit Workflow"}
                                </Button>
                            </div>
                        )}

                        {activeItem === 4 && (
                            <div>
                                <Button
                                    style={{
                                        width: "65px",
                                        minWidth: "65px",
                                        height: "35px",
                                        zIndex: "100",
                                    }}
                                    className="common-btn me-2"
                                    onClick={() => navigateToClientPortal()}
                                    disabled={isLoading}
                                >
                                    Portal
                                </Button>

                                <DropDownButton
                                    text={
                                        <>
                                            <span className="ms-2 pt-1">Add Task </span>
                                            <MdArrowDropDown
                                                size={22}
                                                style={{ marginBottom: "2px" }}
                                            />
                                        </>
                                    }
                                    items={servicesButtonItems.map((item) => ({
                                        ...item,
                                        disabled: !item.action,
                                    }))}
                                    popupSettings={{
                                        animate: false,
                                        popupClass: `${styles["popup"]} me-4`,
                                    }}
                                    buttonClass={`${styles["button-overlay"]} common-btn px-2`}
                                    style={{
                                        height: "35px",
                                    }}
                                    itemRender={itemRender}
                                    onItemClick={(e) =>
                                        servicesButtonItems
                                            .filter((item) => item.text === e.item.text)[0]
                                            ?.action()
                                    }
                                />
                            </div>
                        )}

                        {activeItem === 5 && (
                            <div>
                                <Button
                                    className={`${styles["commonButtonStyle"]} common-btn me-2`}
                                    svgIcon={refreshIcon}
                                    onClick={() => {
                                        setRefreshClicked(true);
                                    }}
                                ></Button>

                                <Button
                                    className={`${styles["wideButtonStyle"]} common-btn `}
                                    onClick={() => setAttachContact(true)}
                                >
                                    Attach Contact
                                </Button>
                            </div>
                        )}

                        {activeItem === 6 && (
                            <div>
                                <Button
                                    className={`${styles["commonButtonStyle"]} common-btn me-2`}
                                    svgIcon={refreshIcon}
                                    onClick={() => {
                                        setRefreshClicked(true);
                                    }}
                                ></Button>
                            </div>
                        )}
                    </div>

                    <TabStrip
                        scrollable={true}
                        onSelect={(e) => setActiveItem(e.selected)}
                        keepTabsMounted={true}
                        selected={activeItem}
                        className="pagetab case-files-tabtitle-width h-100 w-100"
                    >
                        {options.map((item) => {
                            return (
                                <TabStripTab
                                    title={
                                        <PageTabItemTitle
                                            title={item}
                                            index={options.indexOf(item)}
                                            selected={activeItem}
                                        />
                                    }
                                    key={item}
                                    contentClassName="h-100 mt-3"
                                >

                                    {item === "Activities" && (
                                        <CaseActivitiesPage
                                            searchValue={activitySearch}
                                            filterAnchor={filterAnchorRef}
                                            filterContentRef={filterContentRef}
                                            filterClicked={activitiesFilterState.filterClicked}
                                            setFilterClicked={activitiesFilterState.setFilterClicked}
                                            setFilterApplied={activitiesFilterState.setFilterApplied}
                                            filterApplied={activitiesFilterState.filterApplied}
                                            addActivity={addActivity}
                                            refreshClicked={refreshClicked}
                                            setRefreshClicked={setRefreshClicked}
                                            activeItem={activeItem}
                                            setAddActivity={(value) => {
                                                setAddActivity(value);
                                                if (!value) {
                                                    setIsAddActivityBtn(false);
                                                }
                                            }}
                                            addFormText={
                                                currentMatterDetails?.matterRef +
                                                "-" +
                                                currentMatterDetails?.details
                                            }
                                            matterId={props?.id}
                                            matterDetails={currentMatterDetails}
                                            isAddActivityBtn={isAddActivityBtn}
                                        />
                                    )}

                                    {item === "Time Recording" && (
                                        <TimeRecorded
                                            {...props}
                                            filterAnchor={filterAnchorRef}
                                            filterContentRef={filterContentRef}
                                            setFilterApplied={
                                                timeRecordingFilterState.setFilterApplied
                                            }
                                            filterApplied={timeRecordingFilterState.filterApplied}
                                            addTime={addTime}
                                            refreshClicked={refreshClicked}
                                            setRefreshClicked={setRefreshClicked}
                                            filterClicked={timeRecordingFilterState.filterClicked}
                                            setFilterClicked={
                                                timeRecordingFilterState.setFilterClicked
                                            }
                                            activeItem={activeItem}
                                            setAddTime={() => setAddTime(false)}
                                            fromCaseFile={true}
                                            selectedMatterId={currentMatterDetails?.matterId}
                                            matter={currentMatterDetails}
                                        />
                                    )}
                                    {item === "Tasks" && (
                                        <CaseTasks
                                            filterAnchor={filterAnchorRef}
                                            filterContentRef={filterContentRef}
                                            filterClicked={tasksFilterState.filterClicked}
                                            setFilterClicked={tasksFilterState.setFilterClicked}
                                            setFilterApplied={tasksFilterState.setFilterApplied}
                                            filterApplied={tasksFilterState.filterApplied}
                                            addTask={addTask}
                                            addFormText={
                                                currentMatterDetails?.matterRef +
                                                "-" +
                                                currentMatterDetails?.details
                                            }
                                            refreshClicked={refreshClicked}
                                            setRefreshClicked={setRefreshClicked}
                                            activeItem={activeItem}
                                            setAddTask={(value) => setAddTask(value)}
                                            matterId={currentMatterDetails?.matterId}
                                            matterDetails={currentMatterDetails}
                                        />
                                    )}
                                    {item === "Work Flows" && (
                                        <CaseWorkFlows
                                            editWorkflow={editWorkflow}
                                            selTab={props.selTab}
                                            reference={currentMatterDetails}
                                            matterId={currentMatterDetails?.matterId}
                                            refreshClicked={refreshClicked}
                                            setRefreshClicked={setRefreshClicked}
                                            activeItem={activeItem}
                                        />
                                    )}
                                    {item === "Client Services" && (
                                        <div className="h-100">
                                            <ClientServices
                                                matter={currentMatterDetails}
                                                showScreens={showScreens}
                                                setShowScreens={setShowScreens}
                                            />
                                        </div>
                                    )}
                                    {item === "Contacts" && (
                                        <CaseContactsPage
                                            refreshClicked={refreshClicked}
                                            setRefreshClicked={setRefreshClicked}
                                            activeItem={activeItem}
                                            attachContact={attachContact}
                                            setAttachContact={(value) => setAttachContact(value)}
                                            matterId={currentMatterDetails?.matterId}
                                        />
                                    )}
                                    {item === "Ledger Card" && (
                                        <MatterLedgerCardPage
                                            selTab={props.selTab}
                                            reference={currentMatterDetails?.matterId}
                                            refreshClicked={refreshClicked}
                                            setRefreshClicked={setRefreshClicked}
                                            activeItem={activeItem}
                                        />
                                    )}
                                </TabStripTab>
                            );
                        })}
                    </TabStrip>
                </div>
            </div>

            <>
                {showChitRequest && (
                    <ChitRequest
                        cancelEdit={() => {
                            setShowChitRequest(false);
                        }}
                        component={"modal"}
                        setModal={setShowChitRequest}
                        matter={currentMatterDetails}
                    />
                )}

                {showMatterForm && (
                    <MatterForm
                        isView={reference !== undefined}
                        reference={reference}
                        onMatterRefClickActions={onMatterRefClickActions}
                        setshowMatterForm={() => {
                            setshowMatterForm(false);
                            setReference(undefined);
                        }}
                    />
                )}
                {showClientView && !isLoading && (
                    <AddClients
                        data={editData}
                        formId={"view"}
                        onClose={() => {
                            setshowClientView(false);
                        }}
                        open={() => {
                            setshowClientView(true);
                        }}
                        reference={reference}
                        type={"VIEW"}
                    />
                )}
                { }
                {showClientForm && (
                    <Dialog
                        title={"Update Client"}
                        onClose={() => {
                            setShowClientForm(false);
                        }}
                        className="dialog-xxl"
                    >
                        <div className={`container ${styles["clinet-dialog-top-div"]}`}>
                            <div className="">
                                <AddClients
                                    data={editData}
                                    isView={true}
                                    formId={"edit"}
                                    onClose={() => {
                                        setShowClientForm(false);
                                    }}
                                    open={() => {
                                        setShowClientForm(true);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="dialog-footer mt-2 px-0">
                            <Button
                                type="button"
                                className="common-btn bgBtnSecondary border-0 me-2"
                                onClick={() => {
                                    setShowClientForm(false);
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="common-btn me-4"
                                type="submit"
                                onClick={() =>
                                    document.getElementById("client-submitter").click()
                                }
                                form={"edit"}
                            >
                                {"Update Client"}
                            </Button>
                        </div>
                    </Dialog>
                )}
                {showBillingGuide && (
                    <BillingGuideModal
                        onClose={() => setShowBillingGuide(false)}
                        matterId={currentMatterDetails?.matterId}
                    />
                )}
                {openEmailCompletion && (
                    <EmailDialog
                        title={"Email Details"}
                        matterId={currentMatterDetails?.matterId}
                        matter={currentMatterDetails}
                        onClose={() => setOpenEmailCompletion()}
                        openExistingEmailDialog={(e) => {
                            setOpenExistingEmailCompletion(e);
                            setOpenEmailCompletion();
                        }}
                    />
                )}

                {clientTask === "ID-Verification" && (
                    <ClientIdVerification
                        onClose={() => setClientTask()}
                        matterId={currentMatterDetails?.matterId}
                        client={currentMatterDetails?.client}
                    />
                )}

                {showConflictCheck && (
                    <Dialog
                        title={"Conflict Check"}
                        onClose={() => setShowConflictCheck(false)}
                        className="dialog-sm"
                        width={"900px"}
                    >
                        <ConflictCheck
                            onClose={() => setShowConflictCheck(false)}
                            fromCaseFile={true}
                            matterId={currentMatterDetails?.matterId}
                            currentMatterDetails={currentMatterDetails}
                        />
                    </Dialog>
                )}

                {openExistingEmailCompletion && (
                    <EmailCompletion
                        matter={currentMatterDetails}
                        data={openExistingEmailCompletion}
                        onClose={() => setOpenExistingEmailCompletion()}
                    />
                )}

                {billingRequestMatter && (
                    <BillingRequestModal
                        onClose={() => {
                            setBillingRequestMatter(false);
                        }}
                        selectedMatter={billingRequestMatter}
                    />
                )}
            </>
        </div>
    );
};

export default CaseFileView;

const IconContainer = (props) => {
    return (
        <div
            title={props.title}
            className={`${styles["image-block"]
                } d-flex align-items-center justify-content-center ${!props.disabled && "cursor-pointer"
                }`}
            onClick={props.onClick}
        >
            {props.children}
        </div>
    );
};
